import { ErrorStateMatcher } from '@angular/material/core'
import { UntypedFormControl } from '@angular/forms'

export class OpenStatementErrorMatcher implements ErrorStateMatcher {
  private readonly isOptional: boolean

  constructor(isOptional = false) {
    this.isOptional = isOptional
  }

  isErrorState(control: UntypedFormControl): boolean {
    if (!control || this.isOptional) {
      return false
    }

    return !(control.value || '').trim()?.length && (control.dirty || control.touched)
  }
}
